import { IAssetCategoryParameterResponse } from '@kcftech/prometheus-client';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getAssetCategoryParameters } from 'utils/asset_classification';
import { queryClient } from 'utils/query';

const queryKey = 'asset-category-parameters';

export type UseAssetCategoryParametersOptions = Readonly<{
    categoryId: number | undefined;
    removeDuplicates?: boolean;
    includeInherited?: boolean;
}>;

export function useAssetCategoryParameters(
    {
        categoryId,
        removeDuplicates = true,
        includeInherited = false,
    }: UseAssetCategoryParametersOptions,
    queryOptions?: Omit<
        UseQueryOptions<IAssetCategoryParameterResponse[]>,
        'queryKey' | 'queryFn'
    >,
) {
    return useQuery({
        queryKey: [queryKey, categoryId, removeDuplicates, includeInherited],

        queryFn: async () =>
            categoryId === undefined
                ? []
                : getAssetCategoryParameters(
                      categoryId,
                      includeInherited,
                      removeDuplicates,
                  ),

        ...queryOptions,
    });
}

export function invalidateAssetCategoryParameters(categoryId: number) {
    queryClient.invalidateQueries({
        queryKey: [queryKey, categoryId],
    });
}
